export default __webpack_public_path__ + "static/media/OMORFEE.49f21d1f.png";